import React from 'react';
import './App.css'; // Ensure the path is correct for your updated styles

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home.jsx';
import About from './pages/About';
import Menu from './pages/Menu';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery.jsx';
import Footer from './components/Footer.jsx';
import Copyright from './components/Copyright.jsx';

function App() {
  return (
    <Router>
      {/* Navbar */}
      <Navbar />

      {/* Main Content Wrapper */}
      <main> {/* `padding-top` managed by CSS */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </main>

      {/* Footer Section */}
      <Footer />
      <Copyright />
    </Router>
  );
}

export default App;
